import { render, staticRenderFns } from "./DefaultInfo.vue?vue&type=template&id=9cd2d4ba&"
import script from "./DefaultInfo.vue?vue&type=script&lang=js&"
export * from "./DefaultInfo.vue?vue&type=script&lang=js&"
import style0 from "./DefaultInfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports